import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './pages/home/home.component';
import { RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TableComponent } from './components/table/table.component';
import { PrimeNGModule } from './prime.module';
import { SplitButtonModule } from 'primeng/splitbutton';
import { AuthGuard } from './helpers/auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './pages/login/login.component';
import { JobComponent } from './pages/job/job.component';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropDownComponent } from './components/dropDown/dropDown.component';
import { NewPositionComponent } from './pages/addNewPosition/addNewPosition.component';
import { JobDescriptionModalComponent } from './modals/job-description-modal/job-description-modal.component';
import { InputTextComponent } from './components/inputText/inputText.component';
import { InputTextAreaComponent } from './components/inputTextArea/inputTextArea.component';
import { MultiSelectComponent } from './components/multiSelect/multiSelect.component';
import { AssignRecruiterFormComponent } from './pages/assign-recruiter-form/assign-recruiter-form.component';
import { CalenderComponent } from './components/calender/calender.component';
import { CalendarModule } from 'primeng/calendar';
import { JobCommentsComponent } from './pages/job-comments/job-comments.component';
import { ApplicantCreationComponent } from './pages/applicant-creation/applicant-creation.component';
import { InlineErrorMessageComponent } from './components/inlineErrorMessage/inlineErrorMessage.component';
import { ScheduleInterviewComponent } from './pages/scheduleInterview/scheduleInterview.component';
import { ViewScheduledInterviewComponent } from './pages/viewScheduledInterviews/viewInterview.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CandidateFeedbackComponent } from './pages/candidate-feedback/candidate-feedback.component';
import { CandidateEvaluationComponent } from './pages/candidate-evaluation/candidate-evaluation.component';
import { FeedbackPopupComponent } from './pages/feedback-popup/feedback-popup.component';
import { CvsubmitComponent } from './pages/cv-submit/cvsubmit.component';
import { CancelInterviewComponent } from './pages/cancel-interview/cancel-interview.component';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ViewAllInterviewsListComponent } from './pages/view-all-interviews-list/view-all-interviews-list.component';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationDialogComponent } from './modals/confirmationDialog/confirmation-dialog.component';
import { InterviewerDashboardComponent } from './pages/interviewerDashboard/interviewer-dashboard.component';
import { TooltipModule } from 'primeng/tooltip';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ReportsComponent } from './pages/reports/reports.component';
import { TextareaAutosizeModule } from 'ngx-textarea-autosize';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DuplicateCandidateComponent } from './pages/duplicate-candidate/duplicate-candidate.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AssignUserRoleComponent } from './assign-user-role/assign-user-role.component';
import { TabViewModule } from 'primeng/tabview';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AgencyAddEditComponent } from './agency-add-edit/agency-add-edit.component';
import { AgencyModalComponent } from './agency-add-edit/agency-modal/agency-modal.component';
import { TechnologyAddEditComponent } from './technology-add-edit/technology-add-edit.component';
import { TechnologyModalComponent } from './technology-add-edit/technology-modal/technology-modal.component';
import { TemplateAddEditComponent } from './template-add-edit/template-add-edit.component';
import { AddTemplateComponent } from './template-add-edit/add-template/add-template.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PageNotFoundComponent,
    ToolbarComponent,
    TableComponent,
    LoginComponent,
    JobComponent,
    DropDownComponent,
    InputTextComponent,
    InputTextAreaComponent,
    NewPositionComponent,
    AssignRecruiterFormComponent,
    MultiSelectComponent,
    JobDescriptionModalComponent,
    InlineErrorMessageComponent,
    CalenderComponent,
    JobCommentsComponent,
    ApplicantCreationComponent,
    CandidateFeedbackComponent,
    CandidateEvaluationComponent,
    ScheduleInterviewComponent,
    ViewScheduledInterviewComponent,
    FeedbackPopupComponent,
    CvsubmitComponent,
    CancelInterviewComponent,
    ViewAllInterviewsListComponent,
    ConfirmationDialogComponent,
    InterviewerDashboardComponent,
    ReportsComponent,
    DuplicateCandidateComponent,
    DashboardComponent,
    AssignUserRoleComponent,
    AgencyAddEditComponent,
    AgencyModalComponent,
    TechnologyAddEditComponent,
    TechnologyModalComponent,
    TemplateAddEditComponent,
    AddTemplateComponent
  ],
  imports: [
    TextareaAutosizeModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RouterModule,
    HttpClientModule,
    PrimeNGModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    NgxPermissionsModule.forRoot(),
    AutoCompleteModule,
    NgxSpinnerModule,
    AccordionModule,
    TooltipModule,
    ToggleButtonModule,
    SplitButtonModule,
    CheckboxModule,
    InputTextareaModule,
    NgxCaptchaModule,
    TabViewModule,
    DropdownModule,
    RadioButtonModule

  ],
  providers: [NgxSpinnerService, { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy }, AuthGuard, DatePipe],
  bootstrap: [AppComponent],

  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule { }